import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasSubmitFormsAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && !!user.canViewSubmitFormsPage;
    }
}
